import {defineStore} from "pinia";

export const useDataSelectStore = defineStore('dataSelect', {
    state: () => ({
        dataSelect: {},
        dataSelects: [],
        dataSelectsSelect: {
            "WORKER_EXIT_REASON": [],
            "WORKER_COMPANY": [],
            "WORKER_DEPARTMENT": [],
            "WORKER_SERVICE": [],
            "WORKER_TEAM": [],
            "WORKER_STATE": [],
            "WORKER_WORKPLACE": [],
            "WORKER_AFFILIATION": [],
            "WORKER_CNAS_AGENCY": [],
            "WORKER_FAMILY_SITUATION": [],
            "WORKER_SCHOOL_SITUATION": [],
            "WORKER_SICK_POSITION": [],
            "WORKER_CATEGORIZATION": [],
            "CONTRAT_NATURE": [],
            "CONTRAT_EXIT_RATIONALE": [],
            "CNAS_TYPE_DECLARATION": [],
            "CNAS_STATE_DECLARATION": [],
            "CNAS_REFUND_TYPE": [],
            "SHIFA_CART_OPERATION": [],
            "SHIFA_CART_PRINTING_TYPE": [],
            "SHIFA_CART_STATE": [],
            "CARE_FOLDER_STATE": [],
            "CARE_FOLDER_NATURE": [],
            "MUTUAL_PRIME_TYPE": [],
            "MUTUAL_COMPANY": [],
            "DISEASE_SOURCE": [],
            "DISEASE_CLASS": [],
            "DISEASE_NATURE": [],
            "DISEASE_STATE": [],
            "BORDEREAU_TYPE": [],
            "BORDEREAU_MOVING_TYPE": [],
            "CNAS_AGENCY": [],
            "CLAIM_TARGET": [],
            "ADMIN_REQUEST_TARGET": [],
            "RECRUITMENT_REQUESTING_AGENCY": [],
            "RECRUITMENT_TYPE": [],
            "RECRUITMENT_BUDGET": [],
            "RECRUITMENT_REASON": [],
            "RECRUITMENT_CV_TECH_SPECIALITY": [],
            "RECRUITMENT_PLANNING_TYPE": [],
            "PAY_SLIP_TAG": [],
            "TRAINING_DOMAIN": [],
            "TRAINING_CATALOG_CATEGORY": [],
            "EVALUATION_SKILL_CRITERION_CATEGORY": [],
            "EVALUATION_SKILL_CRITERION": [],
            "EVALUATION_PERFORMANCE_CRITERION_CATEGORY": [],
            "EVALUATION_PERFORMANCE_CRITERION": [],
            "EDMS_TAG": []
        },
        loading: false,
    }),
    actions: {
        setLoading(state, loading) {
            state.loading = loading
        },
        setDataSelect(dataSelect) {
            this.dataSelect = dataSelect
        },
        setDataSelectsSelect(dataSelectsSelect, type) {
            this.dataSelectsSelect[type] = dataSelectsSelect;
        },
        addDataSelectsSelect(dataSelectSelect, type) {
            if (!this.dataSelectsSelect[type])
                this.dataSelectsSelect[type] = [];
            this.dataSelectsSelect[type].unshift(dataSelectSelect);
        },
        setDataSelects(dataSelects) {
            this.dataSelects = dataSelects
        },
        addDataSelect(dataSelect) {
            this.dataSelects.unshift(dataSelect)
        },
        updateDataSelect(dataSelect) {
            let index = this.dataSelects.findIndex(cl => cl.id === dataSelect.id)
            this.dataSelects.splice(index, 1, dataSelect)
        },
        deleteDataSelect(dataSelect) {
            let index = this.dataSelects.findIndex(cl => cl.id === dataSelect.id)
            this.dataSelects.splice(index, 1)
        },
    },
});